import {
  initFederation,
  type NativeFederationResult,
} from '@angular-architects/native-federation';

let hostFederation: NativeFederationResult | null = null;

export async function initializeShellFederation(
  manifestUrl?: string,
): Promise<void> {
  const options = { hostRemoteEntry: { url: './remoteEntry.json' } } as const;

  try {
    hostFederation = await initFederation(manifestUrl ?? {}, options);
  } catch (error: unknown) {
    if (!manifestUrl) throw error;

    console.error(
      'O manifesto de remotes falhou; iniciando o shell somente com o mapa local.',
      error,
    );
    hostFederation = await initFederation({}, options);
  }
}

export async function loadShellRemoteModule<TModule>(
  remoteName: string,
  exposedModule = './Routes',
): Promise<TModule> {
  if (!hostFederation) {
    throw new Error('A federação do shell ainda não foi inicializada.');
  }

  return hostFederation.loadRemoteModule<TModule>(remoteName, exposedModule);
}
